import request from "root/js/request";

export const getAnalyticsTextSearchFunnel = async ({
  cabinet_id__in,
  group_by,
  order_by,
  limit,
  offset,
  ...rest
}) => {
  const response = await request({
    url: `/analytics/text_search_funnel/`,
    method: "get",
    params: {
      cabinet_id__in,
      group_by,
      order_by,
      limit,
      offset,
      ...rest,
    },
  });
  return response.data;
};
